const BASE_URL = 'https://api.dev.auxo.dk/public';

/**
 * Hjælpefunktion til at udtrække den korrekte oversættelse fra et lokaliseret felt.
 * Hvis feltet ikke er lokaliseret (rå streng/værdi), returneres det direkte.
 */
export function getVal(field, lang = 'da') {
  if (field === null || field === undefined) return '';
  if (typeof field === 'object' && !Array.isArray(field)) {
    return field[lang] || field['da'] || Object.values(field)[0] || '';
  }
  return field;
}

/**
 * Henter en samling (collection) fra CMS v2 endepunktet med understøttelse af parametre.
 */
export async function fetchCollection(collectionName, params = {}) {
  const url = new URL(`${BASE_URL}/v2/content/${collectionName}`);
  
  Object.entries(params).forEach(([key, val]) => {
    if (val !== undefined && val !== null && val !== '') {
      url.searchParams.append(key, val);
    }
  });

  const res = await fetch(url.toString());
  if (!res.ok) {
    throw new Error(`Kunne ikke hente samlingen: ${collectionName}`);
  }
  return await res.json(); // Returnerer { items, total, limit, offset }
}

/**
 * Henter alle elementer i en samling som et råt array (v1 endepunkt).
 */
export async function fetchCollectionRaw(collectionName) {
  const res = await fetch(`${BASE_URL}/content/${collectionName}`);
  if (!res.ok) {
    throw new Error(`Kunne ikke hente rå samling: ${collectionName}`);
  }
  return await res.json(); // Returnerer et råt array af elementer
}

/**
 * Henter et enkelt element fra en samling ud fra dets ID.
 */
export async function fetchEntryById(collectionName, entryId) {
  const res = await fetch(`${BASE_URL}/content/${collectionName}/${entryId}`);
  if (!res.ok) {
    if (res.status === 404) return null;
    throw new Error(`Kunne ikke hente element ${entryId} fra ${collectionName}`);
  }
  return await res.json();
}

/**
 * Henter et enkelt element ud fra dets slug (for lokaliserede samlinger).
 */
export async function fetchEntryBySlug(collectionName, slug, lang = 'da') {
  const res = await fetch(`${BASE_URL}/by-slug/${lang}/${slug}`);
  if (!res.ok) {
    if (res.status === 404) return null;
    throw new Error(`Kunne ikke hente slug ${slug} for sprog ${lang}`);
  }
  return await res.json();
}

/**
 * Henter alle termer for en taksonomi.
 */
export async function fetchTaxonomyTerms(taxonomyName) {
  const res = await fetch(`${BASE_URL}/taxonomies/${taxonomyName}/terms`);
  if (!res.ok) {
    throw new Error(`Kunne ikke hente taksonomi-termer for: ${taxonomyName}`);
  }
  return await res.json();
}

/**
 * Indsender en formular til vores webform-endepunkt.
 */
export async function submitWebform(formData) {
  const res = await fetch('https://api.dev.auxo.dk/webform/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  });

  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.message || 'Der skete en fejl ved indsendelse af formularen.');
  }

  return await res.json();
}
